import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  style: {"font-size":"15px"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "col-3" }, "Dato:", -1)
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "row mt-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "col-3" }, "Reference ID:", -1)
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "row mt-3" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "col-3" }, "Fejlbesked:", -1)
const _hoisted_17 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, {
        icon: _ctx.icon,
        size: "lg",
        class: "me-3"
      }, null, 8, ["icon"]),
      _createVNode("div", _hoisted_3, [
        _createVNode("h5", _hoisted_4, _toDisplayString(_ctx.message.summary), 1),
        (_ctx.isErrorToast)
          ? (_openBlock(), _createBlock("small", _hoisted_5, [
              _createVNode("a", {
                class: "ml-auto text-muted",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onToggleDetail && _ctx.onToggleDetail(...args))),
                style: {"cursor":"pointer"}
              }, " Klik her for at se flere detajler ")
            ]))
          : (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.message.detail), 1))
      ])
    ]),
    (_ctx.isErrorToast)
      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              _createVNode("b", null, _toDisplayString(_ctx.formatDateTime(_ctx.message.datetime)), 1)
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode("div", _hoisted_14, [
              _createVNode("b", null, _toDisplayString(_ctx.message.correlationId), 1)
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode("div", _hoisted_17, [
              _createVNode("b", null, _toDisplayString(_ctx.message.detail), 1)
            ])
          ])
        ], 512)), [
          [_vShow, _ctx.toggleDetail]
        ])
      : _createCommentVNode("", true)
  ]))
}